function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9837 7.17404C14.2278 5.09283 16.6312 3.998 19.0198 4.42404C21.4083 4.85019 23.2835 6.70841 23.7298 9.09104C24.0748 10.9078 23.5447 12.7747 22.3099 14.1379L22.1194 14.3391L13.5433 22.5197C13.2537 22.7989 12.8101 22.8243 12.4925 22.5959L12.4017 22.5197L3.84795 14.3508C2.27318 12.7528 1.75264 10.3947 2.50908 8.28342C3.26572 6.17201 5.1655 4.67901 7.39776 4.4426C9.63003 4.20621 11.8008 5.26801 12.9837 7.17404ZM18.8294 5.48752C16.9624 5.15451 15.084 5.96365 14.0403 7.52854L13.9144 7.72776L13.0013 9.2551L12.0628 7.74338C11.099 6.1903 9.33034 5.32524 7.51201 5.51779C5.69375 5.7104 4.14628 6.92627 3.52959 8.6467C2.94089 10.2895 3.30017 12.1155 4.42998 13.3908L4.59697 13.5696L12.972 21.5686L21.3509 13.5774C22.4073 12.5156 22.9049 11.0266 22.7073 9.55002L22.6653 9.28928C22.3017 7.34833 20.7743 5.83457 18.8294 5.48752Z",
  fill: "#454555"
});

var SvgIcnHeartNew = function SvgIcnHeartNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnHeartNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn-heart-new.0bdf97cb.svg";
export { ForwardRef as ReactComponent };